import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { saInterCuHandinCellChartConfig } from '../cellChartConfigs';

interface InterCuHandinSaCellProps {
  cellName: string;
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const InterCuHandinSaCell: React.FC<InterCuHandinSaCellProps> = ({ cellName, onFullscreenToggle, isFullscreen }) => {
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);
  return (
    <SiteCharts config={saInterCuHandinCellChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} additionalParams={additionalParams} />
  );
};

export default InterCuHandinSaCell;
